import styled from "styled-components";

export const RoundedTabsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;
`;

export const RoundedTab = styled.div`
  padding: 5px 8px 4px 8px;
  border-radius: 90px;
  border: 1px solid ${({ theme }) => theme.text.title};
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.text.title : theme.text.inverse};
  display: grid;
  place-content: center;
  cursor: pointer;

  &:hover {
    background: ${({ theme, isSelected }) =>
      isSelected ? theme.text.title : theme.border.black10};
  }
`;

export const TabContent = styled.div`
  color: ${({ isSelected, theme }) =>
    isSelected ? theme.text.inverse : theme.text.title};
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: "PP Formula";
`;
